window.addEventListener('load', function () {
  const listingsContainer = document.querySelector(
    '.citizen-participation-listing'
  );
  const listings = listingsContainer.querySelectorAll('.listing');
  const tabs = document.querySelectorAll('.citizen-participation__single-tab');

  addOpenedClassToFirstElement(listings[0]);
  addOpenedClassToFirstElement(tabs[0]);

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      removeOpenedClass(listings);
      removeOpenedClass(tabs);
      tab.classList.add('listing-opened');
      const listingHasSameData = listingsContainer.querySelector(
        '[data-tab="' + tab.dataset.tab + '"]'
      );
      listingHasSameData.classList.add('listing-opened');
    });
  });

  function addOpenedClassToFirstElement(item) {
    item.classList.add('listing-opened');
  }

  function removeOpenedClass(items) {
    items.forEach(function (item) {
      if (item.classList.contains('listing-opened')) {
        item.classList.remove('listing-opened');
      }
    });
  }
});
